<cc-box>
  <div class="details-header container-responsive" *ngIf="event && !!getStatus(event)" header box>
    {{ 'EVENT_DETAILS.STATUS.' + getStatus(event) | translate }}
  </div>
  <div class="details-subheader" *ngIf="event && !!getDate(event)" subheader box>
    {{getDate(event)}}
  </div>
  <div class="card-subtitle"></div>
  <div class="details-content" *ngIf="event" content box>
    <div class="details-content-left">
      <div class="details-content-row" *ngIf="!!getEventType(event)">
        <div class="details-content-row-label">{{ 'EVENT_DETAILS.EVENT_TYPE' | translate }}</div>
        <div class="details-content-row-value">{{ 'CONTACTS_LIST.STATUS.'+getEventType(event)  | translate}}</div>
      </div>
      <div class="details-content-row" *ngIf="!!getCallLength(event)">
        <div class="details-content-row-label">{{ 'EVENT_DETAILS.CALL_LENGTH' | translate }}</div>
        <div class="details-content-row-value">
          <span>{{ getCallLength(event).minutes }}&nbsp;<span translate>MINUTES_SHORT</span>&nbsp;</span>
          <span>{{ getCallLength(event).seconds }}&nbsp;<span translate>SECONDS_SHORT</span></span>
        </div>
      </div>
      <div class="details-content-row" *ngIf="getCallingMode(event)">
        <div class="details-content-row-label">{{ 'EVENT_DETAILS.CALL_MODE' | translate }}</div>
        <div class="details-content-row-value">
          <span>{{ getCallingMode(event) | translate }}</span>
        </div>
      </div>
      <div class="details-content-row" *ngIf="!!getUserName(event)?.length">
        <div class="details-content-row-label">{{ 'EVENT_DETAILS.USER' | translate }}</div>
        <div class="details-content-row-value">{{ getUserName(event) }}</div>
      </div>
      <div class="details-content-row" *ngIf="!getUserName(event)?.length">
        <div class="details-content-row-label">{{'EVENT_DETAILS.USER' | translate }}</div>
        <div class="details-content-row-value">{{'EVENT_DETAILS.NOT_ASSIGNED' | translate }}</div>
      </div>
      <div class="details-content-row" *ngIf="!!getMsisdn(event)">
        <div class="details-content-row-label">{{ 'EVENT_DETAILS.PHONE_NUMBER' | translate }}</div>
        <div class="details-content-row-value phone-number-row">
          <span>{{ getPhoneNumberLabel(event) }}</span>
          <div>
            <span *ngIf="getCountry(event)"
                  class="flag-icon flag-icon-{{getCountry(event)}} m-r-sm shadow-up"></span>
            <span class="phone-number-value">{{ getMsisdn(event) | phoneNumber }}</span>
          </div>
        </div>
      </div>
      <cc-file-drop-player
        *ngIf="event && isRecordingAvailable(event)"
        [voiceMailFileName]="createVoicemailFilename(event)"
        [url]="recordUrl"></cc-file-drop-player>
      <cc-little-loader
        [info]="'EVENT_DETAILS.RECORDING_LOADER_INFO'"
        [visible]="spinnerVisible"></cc-little-loader>
    </div>
    <div class="details-content-right" *ngIf="assignedContacts">
      <div class="details-content-title">{{ 'EVENT_DETAILS.ASSIGNED_CONTACTS' | translate }}</div>
      <div class="details-content-wrapper">
        <div *ngFor="let contact of assignedContacts"
             [routerLink]="['/contact-details/' + contact.id + '/0']"
             class="details-content-row">
          <div class="details-content-row-label">
            <div class="details-content-row-label-user">
              <span *ngIf="contact.firstName">{{ contact.firstName + ' '}}</span>
              <span *ngIf="contact.lastName">{{contact.lastName}}</span>
              <span *ngIf="!contact.firstName && !contact.lastName">{{ 'EVENT_DETAILS.ANONYMOUS' | translate }}</span>
            </div>
            <div *ngIf="contact.email " class="details-content-row-label-email">{{ contact.email }}</div>
          </div>
          <div class="details-content-row-number" *ngIf="contact.extendedMsisdns">
            <span *ngIf="contact.extendedMsisdns.isoCountry"
                  class="flag-icon m-r-xs"
                  [ngClass]="'flag-icon-'+ contact.extendedMsisdns.isoCountry.toLowerCase()"></span>
            <span class="number-itself">{{ contact.extendedMsisdns.msisdn }}</span>
            <cc-call-icon
              *ngIf="contact.extendedMsisdns.isoCountry"
              [number]="contact.extendedMsisdns.msisdn"
            ></cc-call-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</cc-box>

